import { render, staticRenderFns } from "./profile-info.vue?vue&type=template&id=5d3740b1&"
import script from "./profile-info.vue?vue&type=script&lang=js&"
export * from "./profile-info.vue?vue&type=script&lang=js&"
import style0 from "./profile-info.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports